var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUAQMAAADFiO34AAAABlBMVEX/////AP/GWAgeAAAAFElEQVR4AWMgFfyTP/yjHgtJIgAAIskNXeU+cXcAAAAASUVORK5CYII=";
  export default img;